import { useEffect, useState } from 'react';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getUgcTrendDetail } from '@opm/services';
import { ITrendDetail } from '../types';
import { useStableValue } from '@opm/utils/stableKey';

export function useUgcTrendDetail({ filter }: { filter: any }) {
  const [data, setData] = useState<ITrendDetail | null>(null);
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    clear: () => setData(null),
  });

  const stableFilter = useStableValue(filter);

  useEffect(() => {
    if (!stableFilter?.game_id || !stableFilter?.topic) return;
    wrapperCancelRequest(getUgcTrendDetail, stableFilter)
      .then((response: any) => {
        setData(response || null);
      })
      .catch(() => {});
  }, [stableFilter]);

  return { data, loading };
}
